import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchFilterGenresSpotify } from "radar/Service/RadarService";
import { fetchFilterGenres } from "radar/Service/RadarService";

export const getGeneros = createAsyncThunk("generos/get-genero", async () => {
  return await fetchFilterGenres();
});

export const getGenerosSpotify = createAsyncThunk(
  "generos/get-generos-spotify",
  async () => {
    return await fetchFilterGenresSpotify();
  }
);

export const genresSlice = createSlice({
  name: "genres",
  initialState: {
    genres: [],
    genreOptions: [],
    genresSpotify: [],
    genreByKeys: {},
    loading: true,
  },
  reducers: {
    setGenreOptionsI18n: (state, action) => {
      state.genreOptions = state.genres.map((genre: any) => ({
        label: genre[`${action.payload}`],
        value: genre.code,
      })) as any;

      state.genreByKeys = state.genres.reduce((r: any, e: any) => {
        r[e.code] = { ...e };
        return r;
      }, {});
    },
  },
  extraReducers: {
    [getGeneros.fulfilled.type]: (state, action) => {
      if (action.payload) {
        state.genres = action.payload;
        state.genreByKeys = action.payload.reduce((r: any, e: any) => {
          r[e.code] = { ...e };
          return r;
        }, {});
        state.loading = false;
      }
    },
    [getGenerosSpotify.fulfilled.type]: (state, action) => {
      if (action.payload) {
        state.genresSpotify = action.payload;
        state.loading = false;
      }
    },
  },
});

export const { setGenreOptionsI18n } = genresSlice.actions;

export default genresSlice.reducer;
